// Verifica se está na página Contatos
let pagContato = document.querySelector(".pag-contato");
if(pagContato){
  // Exibe e esconde select Formulário Coontato

  // Select Tipo do Evento
  const tipoEvento = document.querySelector("#tipoEvento");
  
  // Selects Radio
  const eventosCorporativos = document.querySelector("#eventosCorporativos");
  const eventosSociais = document.querySelector("#eventosSociais");
  const casamentos = document.querySelector("#casamentos");
  
  // Func verifica e adiciona hide
  function escondeRadio(evento) {
    if (!evento.classList.contains("hide")) {
      evento.classList.add("hide");
    }
  }
  
  // Func limpa o select escolhido por engano ao trocar Tipo de Evento
  function limpaSelect(evento) {
    // Limpar todos os radios dentro do contêiner
    const radios = evento.querySelectorAll("input[type='radio']");
    radios.forEach((radio) => (radio.checked = false));
  }
  
  // verifica o Tipo de Evento ativo
  tipoEvento.addEventListener("change", () => {
    switch (tipoEvento.value) {
      case "Evento Corporativo":
        escondeRadio(eventosSociais);
        limpaSelect(eventosSociais);
        escondeRadio(casamentos);
        limpaSelect(casamentos);
        eventosCorporativos.classList.remove("hide");
        break;
      case "Evento Social":
        escondeRadio(eventosCorporativos);
        limpaSelect(eventosCorporativos);
        escondeRadio(casamentos);
        limpaSelect(casamentos);
        eventosSociais.classList.remove("hide");
        break;
      case "Casamento":
        escondeRadio(eventosCorporativos);
        limpaSelect(eventosCorporativos);
        escondeRadio(eventosSociais);
        limpaSelect(eventosSociais);
        casamentos.classList.remove("hide");
        break;
      default:
        escondeRadio(eventosCorporativos);
        limpaSelect(eventosCorporativos);
        escondeRadio(eventosSociais);
        limpaSelect(eventosSociais);
        escondeRadio(casamentos);
        limpaSelect(casamentos);
        break;
    }
  });
}
